import { render, staticRenderFns } from "./sortmanage.vue?vue&type=template&id=3dc45103&scoped=true&"
import script from "./sortmanage.vue?vue&type=script&lang=js&"
export * from "./sortmanage.vue?vue&type=script&lang=js&"
import style0 from "./sortmanage.vue?vue&type=style&index=0&id=3dc45103&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc45103",
  null
  
)

export default component.exports